export default {
  techExcelFiles: (state) => state.techExcelFiles,
  techInfrastructure: (state) => state.techInfrastructure,
  techInfrastructureMap: (state) => {
    const mapInfrastructure = {}
    state.techInfrastructure.forEach(infrastructure => {
      mapInfrastructure[infrastructure.id] = infrastructure
    })
    return mapInfrastructure
  },
  techMapData: (state) => state.techMapData,
  forceTechMapCenter: (state) => state.forceTechMapCenter,
  forceTechMapBounds: (state) => state.forceTechMapBounds,
  techMapParams: (state) => state.techMapParams,
  techLoadingData: (state) => state.techLoadingData,
  techSelectedInfrastructure: (state) => state.techSelectedInfrastructure,
}



// WEBPACK FOOTER //
// ./src/store/technologies/getters.js